import React, { useEffect, useState } from "react";
import { X, CreditCard, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const PURCHASABLE_SLUGS = ["myevent-essentiel", "myevent-premium", "myevent-signature"];

export default function SubscribePlanModal({ eventId, open, onClose }) {
  const [plans, setPlans] = useState([]);
  const [busy, setBusy] = useState(null); // plan_id currently being subscribed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get("/myadmin/plans")
      .then(r => setPlans((r.data.plans || []).filter(p => PURCHASABLE_SLUGS.includes(p.slug) && p.active)))
      .catch(() => toast.error("Impossible de charger les forfaits."))
      .finally(() => setLoading(false));
  }, [open]);

  const subscribe = async (plan) => {
    setBusy(plan.id);
    try {
      const { data } = await api.post(`/next/events/${eventId}/subscribe`, {
        plan_id: plan.id,
        origin_url: window.location.origin,
      });
      toast.success("Redirection vers Stripe TEST…");
      window.location.assign(data.checkout_url);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur lors du démarrage du paiement.");
      setBusy(null);
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-6" data-testid="subscribe-modal">
      <div className="card-luxe max-w-4xl w-full max-h-[90vh] overflow-y-auto p-8 relative">
        <button onClick={onClose} data-testid="subscribe-modal-close"
          className="absolute top-4 right-4 text-white/50 hover:text-[#DCB457]">
          <X size={18} />
        </button>
        <p className="eyebrow">Souscription · Stripe TEST</p>
        <h2 className="font-serif-luxe text-3xl mt-2 mb-2">Attribuer un <span className="italic gold-text">forfait</span></h2>
        <p className="text-xs text-white/50 mb-6">
          Mode TEST · Carte 4242 4242 4242 4242 · Aucune facturation réelle.
        </p>

        {loading ? (
          <p className="text-white/50 italic text-sm">Chargement des forfaits…</p>
        ) : plans.length === 0 ? (
          <p className="text-white/50 italic text-sm">Aucun forfait achetable disponible.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {plans.map(p => (
              <div key={p.id} data-testid={`subscribe-card-${p.slug}`}
                className={`border p-5 flex flex-col ${p.highlighted ? "border-[#DCB457] bg-[#DCB457]/5" : "border-[#DCB457]/25"}`}>
                <p className="text-[10px] uppercase tracking-widest text-white/45">{p.slug}</p>
                <h3 className="font-serif-luxe text-xl mt-1">{p.name}</h3>
                <p className="font-serif-luxe text-3xl gold-text mt-3">{p.price} €</p>
                <p className="text-xs text-white/60 mt-2 leading-relaxed flex-1">{p.description}</p>
                <button onClick={() => subscribe(p)} disabled={busy !== null}
                  data-testid={`subscribe-btn-${p.slug}`}
                  className="mt-5 inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-[#DCB457] text-black text-xs uppercase tracking-widest disabled:opacity-50 hover:bg-[#DCB457]/90">
                  {busy === p.id ? "Redirection…" : (<><CreditCard size={14} /> Souscrire</>)}
                </button>
              </div>
            ))}
          </div>
        )}
        <p className="mt-6 text-[10px] uppercase tracking-widest text-white/35 inline-flex items-center gap-1.5">
          <ExternalLink size={11} /> Stripe TEST · pas de vraie carte, pas de vrai débit
        </p>
      </div>
    </div>
  );
}
